import { Component } from 'js-component-framework';
import { AriaPopup } from 'js-component-framework/lib/plugins';

/**
 * Component for search flyout
 */
export default class Subnav extends Component {
  static getViewportWidth() {
    const viewportWidth = window.innerWidth
      || document.documentElement.clientWidth;
    return viewportWidth;
  }

  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.init();
  }

  clickHandler(event, popup) {
    if (650 > this.getViewportWidth) {
      event.preventDefault();
      event.stopPropagation();
      popup.ariaToggle(event);
    }
  }

  /**
   * For a page wrapper, find sidebar, assess height, and wrap first or second children to prevent overlap.
   */
  handleContentOffset() {
    const {
      element,
    } = this;
    // Get height of the subnav.
    const height = element.offsetHeight;

    // If our subnav is larger than expected, proceed.
    if (250 < height) {
      const appendWrapper = (item) => {
        // Create wrapper container.
        const wrapper = document.createElement('div');
        wrapper.classList.add('side-nav--wrapper');
        // Insert wrapper before our first child in the DOM tree.
        item.parentNode.insertBefore(wrapper, item);
        // Move our first child into wrapper.
        wrapper.appendChild(item);
      };

      // Get the page content wrapper.
      const contentWrapper = document.querySelector('.entry__content')
        || document.querySelector('.entry__content-wrapper');
      // Get content wrapper children.
      const contentChildren = contentWrapper.children;

      if (0 < contentChildren.length) {
        // Get first three from array of HTMLCollection (will return 1 if 1).
        const children = Array.from(contentChildren).slice(0, 3);

        // Loop over children.
        children.every((item, index) => {
          // Don't wrap the TOC block in the wrapper, if it exists
          if (item.classList.contains('block--table-of-contents')) {
            return true;
          }
          // If our first element doesn't have the rich text class OR it does
          // and we're on our second item and it also does not have the
          // rich-text class, wrap it in rich text.
          if (
            0 === index
              && ! item.classList.contains('rich-text')
          ) {
            appendWrapper(item);
            return false;
          }

          appendWrapper(item);
          return true;
        });
      }
    }
  }

  init() {
    const {
      controller,
      target,
    } = this.children;

    const {
      options: {
        ariapopup: attributes,
      },
    } = this;

    if (! controller || ! target) {
      return;
    }

    this.handleContentOffset();

    this.popup = new AriaPopup({
      controller,
      target,
      attributes,
      loadOpen: false,
      hasTransition: true,
    });

    this.popup.controller.addEventListener('click', (e) => this
      .clickHandler(e, this.popup));
  }
}
